import { render } from "./ArticleComments.vue?vue&type=template&id=17de65d3"
import script from "./ArticleComments.vue?vue&type=script&lang=js"
export * from "./ArticleComments.vue?vue&type=script&lang=js"

import "./ArticleComments.vue?vue&type=style&index=0&id=17de65d3&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__